import React from 'react'

export default React.memo(() => {
  return <span className={'secondary-text'}>No Data</span>
})
